import { useDispatch } from 'react-redux';
import useLoading from '../useLoading';
import { updateProductsFromBalance } from '../../store/slices/sale/creditNoteSaleLookupSlice';
import CreditNoteBalanceService from '../../services/sale/CreditNoteBalanceService';
import { mapToProductSummaries } from '../../types/sale/creditNote/mapToProductSummaries';

export const useCreditNoteBalance = () => {
  const dispatch = useDispatch();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const fetchProductBalances = async (
    creditNoteId: number,
    creditFiscalSaleId: number
  ) => {
    try {
      showLoadingIndicator();

      const balances = await CreditNoteBalanceService.getBalances(
        creditNoteId,
        creditFiscalSaleId
      );

      const mappedProducts = mapToProductSummaries(balances);
      dispatch(updateProductsFromBalance(mappedProducts));
    } catch (error) {
      console.error('❌ Error al obtener balances de productos:', error);
    } finally {
      hideLoadingIndicator();
    }
  };

  return {
    fetchProductBalances,
  };
};
